module.exports = __webpack_public_path__ + "static/media/ericsson.7537a95b.png";